//Unknown asset
require("file-loader?name=asset-symbols/[name].png!./unknown.png"); // Core asset


require("file-loader?name=asset-symbols/[name].png!./bts.png"); // BitAssets


require("file-loader?name=asset-symbols/[name].png!./usd.png");

require("file-loader?name=asset-symbols/[name].png!./eur.png");

require("file-loader?name=asset-symbols/[name].png!./cny.png");

require("file-loader?name=asset-symbols/[name].png!./gold.png");

require("file-loader?name=asset-symbols/[name].png!./btc.png");

require("file-loader?name=asset-symbols/silver.png!./silver.png"); // PIRATE


require("file-loader?name=asset-symbols/[name].png!./pirate.png");

require("file-loader?name=asset-symbols/[name].png!./pirate.cosa.png");

require("file-loader?name=asset-symbols/[name].png!./pirate.ltc.png");

require("file-loader?name=asset-symbols/[name].png!./pirate.btc.png");

require("file-loader?name=asset-symbols/[name].png!./pirate.bcc.png");

require("file-loader?name=asset-symbols/[name].png!./pirate.doge.png");

require("file-loader?name=asset-symbols/[name].png!./pirate.pirate.png"); // 3rd party assets


require("file-loader?name=asset-symbols/[name].png!./eth.png");

require("file-loader?name=asset-symbols/[name].png!./steem.png");

require("file-loader?name=asset-symbols/[name].png!./mkr.png");

require("file-loader?name=asset-symbols/[name].png!./dgd.png");

require("file-loader?name=asset-symbols/[name].png!./obits.png");

require("file-loader?name=asset-symbols/[name].png!./btsr.png");

require("file-loader?name=asset-symbols/[name].png!./dao.png");

require("file-loader?name=asset-symbols/[name].png!./lisk.png");

require("file-loader?name=asset-symbols/[name].png!./peerplays.png");

require("file-loader?name=asset-symbols/[name].png!./icoo.png");

require("file-loader?name=asset-symbols/[name].png!./blockpay.png");

require("file-loader?name=asset-symbols/[name].png!./dash.png");

require("file-loader?name=asset-symbols/[name].png!./eurt.png");

require("file-loader?name=asset-symbols/[name].png!./game.png");

require("file-loader?name=asset-symbols/[name].png!./grc.png");

require("file-loader?name=asset-symbols/[name].png!./usdt.png");

require("file-loader?name=asset-symbols/[name].png!./bkt.png");

require("file-loader?name=asset-symbols/kapital.png!./bkt.png");

require("file-loader?name=asset-symbols/[name].png!./dct.png");

require("file-loader?name=asset-symbols/[name].png!./incnt.png");

require("file-loader?name=asset-symbols/[name].png!./nxc.png");

require("file-loader?name=asset-symbols/[name].png!./btwty.png");

require("file-loader?name=asset-symbols/[name].png!./open.btc.png");

require("file-loader?name=asset-symbols/[name].png!./hempsweet.png");

require("file-loader?name=asset-symbols/[name].png!./eos.png");

require("file-loader?name=asset-symbols/[name].png!./yoyow.png");

require("file-loader?name=asset-symbols/[name].png!./hero.png");

require("file-loader?name=asset-symbols/[name].png!./ruble.png");

require("file-loader?name=asset-symbols/[name].png!./oct.png");

require("file-loader?name=asset-symbols/[name].png!./smoke.png");

require("file-loader?name=asset-symbols/[name].png!./stealth.png");

require("file-loader?name=asset-symbols/[name].png!./kexcoin.png");

require("file-loader?name=asset-symbols/[name].png!./bto.png");

require("file-loader?name=asset-symbols/[name].png!./btm.png");

require("file-loader?name=asset-symbols/[name].png!./krm.png");

require("file-loader?name=asset-symbols/[name].png!./golos.png");

require("file-loader?name=asset-symbols/[name].png!./gbg.png");

require("file-loader?name=asset-symbols/[name].png!./atn.png");

require("file-loader?name=asset-symbols/[name].png!./neo.png");

require("file-loader?name=asset-symbols/[name].png!./gas.png");

require("file-loader?name=asset-symbols/[name].png!./qtum.png");

require("file-loader?name=asset-symbols/[name].png!./bkbt.png");

require("file-loader?name=asset-symbols/[name].png!./dht.png");

require("file-loader?name=asset-symbols/[name].png!./gxs.png");

require("file-loader?name=asset-symbols/[name].png!./scr.png");

require("file-loader?name=asset-symbols/[name].png!./zeph.png");

require("file-loader?name=asset-symbols/[name].png!./egem.png");

require("file-loader?name=asset-symbols/[name].png!./hertz.png");

require("file-loader?name=asset-symbols/[name].png!./dgb.png");

require("file-loader?name=asset-symbols/[name].png!./doge.png");

require("file-loader?name=asset-symbols/[name].png!./tusd.png");

require("file-loader?name=asset-symbols/[name].png!./zec.png");

require("file-loader?name=asset-symbols/[name].png!./waves.png");

require("file-loader?name=asset-symbols/[name].png!./zrx.png");

require("file-loader?name=asset-symbols/[name].png!./xrp.png");

require("file-loader?name=asset-symbols/[name].png!./xmr.png");

require("file-loader?name=asset-symbols/[name].png!./sbd.png");

require("file-loader?name=asset-symbols/[name].png!./sth.png");

require("file-loader?name=asset-symbols/[name].png!./kec.png");

require("file-loader?name=asset-symbols/[name].png!./ltc.png");

require("file-loader?name=asset-symbols/[name].png!./post.png");

require("file-loader?name=asset-symbols/[name].png!./bch.png");

require("file-loader?name=asset-symbols/[name].png!./btg.png");

require("file-loader?name=asset-symbols/[name].png!./mdl.png");

require("file-loader?name=asset-symbols/[name].png!./cof.png");

require("file-loader?name=asset-symbols/[name].png!./exr.png");

require("file-loader?name=asset-symbols/[name].png!./lcrt.png");

require("file-loader?name=asset-symbols/[name].png!./nvc.png");

require("file-loader?name=asset-symbols/[name].png!./atri.png");

require("file-loader?name=asset-symbols/[name].png!./bat.png");

require("file-loader?name=asset-symbols/[name].png!./fil.png");

require("file-loader?name=asset-symbols/[name].png!./usdc.png");

require("file-loader?name=asset-symbols/[name].png!./usdn.png");

require("file-loader?name=asset-symbols/[name].png!./evraz.png"); // 3rd party assets (RuDEX)


require("file-loader?name=asset-symbols/[name].png!./ppy.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.btc.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.usdt.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.eos.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.eth.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.gbg.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.golos.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.grc.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.krm.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.sbd.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.smoke.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.steem.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.wls.png");

require("file-loader?name=asset-symbols/[name].png!./rudex.pzm.png");

require("file-loader?name=asset-symbols/[name].png!./evraz.png");